import { Component } from '@grafikr/components'
import { fetchCart } from '@/lib/cart.js'

export default Component((node, { app, dispatchEvent }) => {
    const giftVariantId = node.dataset.gift;
    const giftText = node.dataset.giftText;
    const giftGoal = Number(node.dataset.goal);

    let ifGiftProductInCart;
    fetchCart().then((cart) => {
        ifGiftProductInCart = cart.items.find(item => item.properties?.GWP);
    });  
    document.addEventListener('cart:updated', function (e) {
        const data = e.detail;

        fetchCart().then((cart) => {
            ifGiftProductInCart = cart.items.find(item => item.properties?.GWP)
        })
        .then(async () => {
            if (ifGiftProductInCart && Object.keys(ifGiftProductInCart).length != 0) {
                return
            }

            if (window.theme.gwp_eligible_collection) {
              const eligibleProducts = await fetch(`${Shopify.routes.root}cart?view=gwp`).then((res) => res.json())

              if (eligibleProducts.length === 0) return

              const eligibleProductsPrice = eligibleProducts
                .map((product) => product.final_line_price / 100)
                .reduce((a, b) => a + b, 0)

              if (eligibleProductsPrice <= giftGoal) return
            } else {
                const cartPrice = (data.cart?.total_price || data.total_price) / 100;
                if (cartPrice <= giftGoal) return;
            }

            let formData = {
                'items': [{
                    'id': giftVariantId,
                    'quantity': 1,
                    'properties': {
                        "GWP": giftText
                    }
                }]
            }

            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then(response => {
                return response.json()
            })
            .then(() => {
                fetchCart().then((cart) => {
                    window.theme.cart = cart
                    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }))
                })
            })
            .catch((error) => {
                console.error('Error:', error)
            })
        })
    })
})  